import React from 'react'
import { Container, Row } from 'react-bootstrap'

const NotFound = () => {
  return (
    <>
    <hr />
        <Container>
            <Row>
                <h1 className='text-center pt-5'>Page Not Found</h1>
            </Row>
        </Container>
    </>
  )
}

export default NotFound
